<template>

  <b-modal
      id="validate-for-sign-pro-modal"
      modal-class='form validate-for-sign-pro-modal'
      modal-footer="hide"
      scrollable
      centered
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Valider pour signature"
  >

    <div class="form form__addChallenge">
      <p>Souhaitez vous valider vos PRO Pour signature.</p>
    </div>

    <template v-slot:modal-footer>
      <b-button
          class="btn-secondary"
          @click="closeMe()">
        Annuler
      </b-button>
      <b-button
          class="btn-primary"
          @click="sendPro()">
        Valider
      </b-button>
    </template>

  </b-modal>
</template>

<script>

export default {
  name: "ValidateForSignProModal",
  methods:{
    onSubmit(evt) {
      evt.preventDefault()
    },
    onReset() {
      // Reset our form values
      this.form.other = null;
      this.form.participated = null;
    },
    //CLOSE THE POPUP
    closeMe(){
      this.$root.$emit('bv::hide::modal', 'validate-for-sign-pro-modal');
    },
    sendPro() {
      this.$emit('send', true);
      this.$root.$emit('bv::hide::modal', 'validate-for-sign-pro-modal');
    }
  },
}
</script>

